export namespace MajorCombinedConst {
  export const MajorTypes = {
    MJ_IN_FREE_LOOK: 'MAJOR_CHANGE_IN_FREE_LOOK',
    MJ_AFTER_FREE_LOOK: 'MAJOR_CHANGE_AFTER_FREE_LOOK'
  }
}